import React from 'react';
import FilingStatusSummary from '../../diy-return/components/FilingStatusSummary';
import ReturnStatusIcon from '../../diy-return/components/ReturnStatusIcon';
import Skeleton from '../../../components/library/loaders/Skeleton';
import CollapsibleCardHeader from '../../../components/library/stacking-collapsible-cards/CollapsibleCardHeader';
import FilingStatusRow from '../../diy-return/components/FilingStatusRow';
import StackableCardWrapper from '../../../components/library/stacking-collapsible-cards/StackableCardWrapper';

const SkeletonFilingStatusCard = () => (
    <StackableCardWrapper>
        <div className='stackable-section'>
            <CollapsibleCardHeader icon={<ReturnStatusIcon dashboardStatus='IN_PROGRESS' netfileStatus='IN_PROGRESS' />} collapsed>
                <div className='column is-8 pl-0 ml-0'>
                    <Skeleton />
                </div>
                <div className='column is-4'>
                    <Skeleton />
                </div>
            </CollapsibleCardHeader>
            <FilingStatusSummary CRAStatus={null} RQStatus={null} T1135Status={null} collapsed={true} boldText={true} loading />
            <FilingStatusRow submissionType='CRA' loading />
        </div>
    </StackableCardWrapper>
)

export default SkeletonFilingStatusCard